export default {
      id: "deposit-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#deposit",
      toString: function () {
        return this.url;
      }
    }